import * as React from "react";
import { toast } from "react-toastify";

import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useDeleteConversationMutation } from "../api";
import { RecentQAConversation } from "../types";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  conversation: RecentQAConversation;
  onDeleted?: () => void;
}

export const DeleteConversationModal: React.FC<Props> = ({ isOpen, setIsOpen, conversation, onDeleted }) => {
  const [deleteConversation, { isLoading }] = useDeleteConversationMutation();

  const onClick = async () => {
    try {
      await deleteConversation({
        conversation_id: conversation.conversation_id,
      }).unwrap();
      setIsOpen(false);
      toast.success("Conversation deleted");
      onDeleted?.();
    } catch {
      toast.error("Failed to delete conversation");
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete conversation</DialogTitle>
        </DialogHeader>

        <p>Are you sure you want to delete this conversation? This action cannot be undone.</p>

        <DialogFooter className="mt-4">
          <Button type="button" variant="outline" onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button type="button" variant="destructive" onClick={onClick} disabled={isLoading}>
            {isLoading ? "Deleting..." : "Confirm Delete"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
